module.exports = __webpack_public_path__ + "img/marth-min.c98f5442.png";